import CalcRouteView from '../calc-route/CalcRouteView.vue';
import MapLayout from '@/templates/MapLayout';

export default [
  {
    path: '/calc/route',
    name: 'calcRoute',
    component: CalcRouteView,
    meta: {
      title: 'Cálculo de rutas',
      layout: MapLayout,
      isSlim: true,
      materialIcon: 'directions_car',
    },
  },
];
